module.exports = __webpack_public_path__ + "img/Investigation.fafbbb2f.svg";